export const API_BASE_URL =
  "https://triverseadvertising.com/iec_website_clone/admin-portal/api/";
